import whitney from "../../../image/originals/hollywoodicons/whitney.webp"; 
import ItemNoSize from "../ItemNoSize";

const Shop = () => {
  const items = [
    {
      id: "92_base",
      name: "Whitney Houston Print",
      image: whitney, // Main image without .webp
      price: "empty for now",
      thumbnails: [whitney], // Other images (if available)
      description: 'Roughly 20" x 20" Museum Rag Paper.',
      projectUrl: "/WhitneyHoustonPrint",
      sizes: ["blank"],
    },
  ];

  return <ItemNoSize items={items} />;
};

export default Shop;
